const KupciInGraditelji = () => {
  return <div>KupciInGraditelji</div>;
};

export default KupciInGraditelji;
